import React from 'react';
import { Table } from 'reactstrap';
import { OperationalToleranceSectionValue } from '../../../../shared/offer-domain/ui';
import { displayValue } from '../../../../utils/format';
import {
  formatIncotermRoute,
  formatParcelSize,
} from '../../../TenderEvaluation/utils/deliveryDetailUtils';
import {
  buildPortSlots,
  parcelUnit,
  requirementToleranceProcurement,
} from '../../utils/roomSpec';
import RoomPanel from './RoomPanel';

export const SpecHead = ({ labels }) => (
  <thead className='table-light'>
    <tr>
      {labels.map(label => (
        <th key={label}>
          <span className='text-uppercase fw-bold fs-12 text-muted'>
            {label}
          </span>
        </th>
      ))}
    </tr>
  </thead>
);

export const PortCell = ({ port }) => {
  if (!port) return <span className='text-muted'>-</span>;
  const portLabel = port.names?.length ? port.names.join(', ') : port.name;
  return (
    <div className='small text-dark'>
      <div>
        <span className='text-muted'>Port:</span> {portLabel}
      </div>
      <div>
        <span className='text-muted'>Parcel size:</span> {port.parcel}
      </div>
      <div>
        <span className='text-muted'>Date:</span> {port.date}
      </div>
    </div>
  );
};

const requirementSource = cargo => {
  const raw = cargo?.requirement || {};
  return {
    ...(raw.detail || {}),
    ...(raw.quantity || {}),
    ...raw,
    timeline: raw.timeline || raw.detail?.timeline || raw.quantity?.timeline,
    fobLocationNames:
      raw.fobLocationNames ||
      raw.detail?.fobLocationNames ||
      raw.quantity?.fobLocationNames,
  };
};

const RequirementTable = ({ cargo, procurement }) => {
  const req = requirementSource(cargo);
  const ports = buildPortSlots(req, { unit: parcelUnit(procurement) });
  const basisRaw = req.deliveryBasis ?? req.parcelSize;
  const basis =
    basisRaw == null || basisRaw === ''
      ? null
      : formatParcelSize(basisRaw, parcelUnit(procurement));
  const incotermRoute =
    req.incotermRoute || formatIncotermRoute(req.incoterm, req.route);

  return (
    <RoomPanel
      title='Requirement'
      description='Delivery terms Pertamina asked for on this cargo'
      icon='ri-file-list-3-line'
    >
      <div className='table-responsive'>
        <Table className='neg-spec-table align-middle mb-0'>
          <SpecHead
            labels={[
              'Delivery basis',
              'Incoterm - Route',
              'Operation tolerance',
              'Port 1',
              'Port 2',
              'Port 3',
            ]}
          />
          <tbody>
            <tr>
              <td>{displayValue(basis)}</td>
              <td>
                {displayValue(incotermRoute === '-' ? null : incotermRoute)}
              </td>
              <td>
                <OperationalToleranceSectionValue
                  procurement={requirementToleranceProcurement(
                    req,
                    procurement
                  )}
                  showCounter={false}
                />
              </td>
              {ports.map((port, index) => (
                <td key={`port-${index}`}>
                  <PortCell port={port} />
                </td>
              ))}
            </tr>
          </tbody>
        </Table>
      </div>
    </RoomPanel>
  );
};

export default RequirementTable;
